import { ItemIconConfig } from '@client/modules/discovery/ui/filters/types';
import i18nInstance from '@client/monolith/legacy/services/i18n';

export const filterIconConfig: Record<string, ItemIconConfig> = {
  proven_success: {
    symbol: 'arrow-repeat-check',
    background: 'accent',
    text: 'accent-alt',
    tooltip: {
      get title() {
        return i18nInstance.global.t('discovery.product.badges.proven-success');
      },
      get text() {
        return i18nInstance.global.t('discovery.catalog.filters.proven-success.copy');
      },
      get actionText() {
        return i18nInstance.global.t('discovery.catalog.filters.proven-success.link');
      },
    },
  },
  fast_shipping: {
    symbol: 'truck-fast',
    background: 'info-700',
    text: 'white',
    tooltip: {
      get title() {
        return i18nInstance.global.t('discovery.product.badges.fast-delivery');
      },
      get text() {
        return i18nInstance.global.t('discovery.catalog.filters.fast-delivery.copy');
      },
      get actionText() {
        return i18nInstance.global.t('discovery.catalog.filters.fast-delivery.link');
      },
    },
  },
  repeat_offers: {
    symbol: 'ankorstore-plus',
    background: 'accent-alt',
    text: 'black',
    tooltip: {
      get title() {
        return i18nInstance.global.t('ankorstorePlus.program.name');
      },
      get text() {
        return i18nInstance.global.t('ankorstorePlusPill.content');
      },
      get actionText() {
        return i18nInstance.global.t('ankorstorePlus.cta.nonOptIn');
      },
    },
  },
  trending_product: {
    symbol: 'graph-up',
    background: 'warning-300',
    text: 'warning-700',
    tooltip: {
      get title() {
        return i18nInstance.global.t('discovery.product.badges.trending');
      },
      get text() {
        return i18nInstance.global.t('discovery.catalog.filters.trending.copy');
      },
    },
  },
  new_brands: {
    symbol: 'award',
    background: 'cold-400',
    text: 'cold-800',
    tooltip: {
      get title() {
        return i18nInstance.global.t('discovery.product.badges.new-brands');
      },
      get text() {
        return i18nInstance.global.t('discovery.catalog.filters.new-brands.copy');
      },
    },
  },
};
